module.exports = __webpack_public_path__ + "assets/link.7310180f.svg";